export default __webpack_public_path__ + "1.19.2/static/media/chevron-right.f060fc1b.svg";